package com.merkost.handpass.admin.api

import io.ktor.client.HttpClient
import io.ktor.client.engine.js.Js
import io.ktor.client.request.put
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType
import io.ktor.http.isSuccess
import kotlinx.coroutines.await
import kotlin.js.Promise
import org.khronos.webgl.ArrayBuffer
import org.khronos.webgl.Int8Array
import org.w3c.files.File

private val uploadClient = HttpClient(Js)

suspend fun uploadFileToPresignedUrl(uploadUrl: String, file: File, contentType: String): Boolean {
    val buffer = file.asDynamic().arrayBuffer().unsafeCast<Promise<ArrayBuffer>>().await()
    val bytes = Int8Array(buffer).unsafeCast<ByteArray>()
    val response = uploadClient.put(uploadUrl) {
        contentType(ContentType.parse(contentType))
        setBody(bytes)
    }
    return response.status.isSuccess()
}
